module.exports = __webpack_public_path__ + "static/web_JS6-fcece2faab8bb2f33be7659c56b66b5a.jpg";